var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"announcement",style:(_vm.elStyle)},[_c('div',{staticClass:"message",on:{"click":_vm.msgClick}},[_c('EllipsisDiv',{key:_vm.messageKey,staticClass:"message-content",attrs:{"text":_vm.announcement.message}})],1),_c('img',{staticClass:"close",attrs:{"alt":"","src":_vm.closeImgSrc},on:{"click":_vm.close}})])
}
var staticRenderFns = []

export { render, staticRenderFns }